import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThirdParty } from '../../entity/third-party';
import { Subject } from 'rxjs/Subject';
import { RelationSearchService } from './relation-search.service';

const delayBeforeSearch = 500;
@Component({
    selector: 'app-relation-search',
    templateUrl: './relation-search.component.html'
})
export class RelationSearchComponent implements OnInit {
    @Input() preFilledThirdParty: ThirdParty;
    @Input() thirdPartyExists: boolean;
    @Input() relationDestination: string;
    @Input() thirdPartyRelationType: string;
    // emits an object containing the result of a relation search
    @Output() onNewSearch: EventEmitter<any> = new EventEmitter<any>();
    // emits a boolean each time a search begins / ends
    @Output() onSearchEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    searching: boolean;
    search: string;
    thirdParty: ThirdParty;
    foundThirdParty: boolean;
    private debouncer: Subject<string> = new Subject();

    constructor(
        private relationSearchService: RelationSearchService,
    ) {}

    ngOnInit(): void {
        this.thirdParty = this.preFilledThirdParty || null;
        this.search = this.thirdParty  !== null ? this.thirdParty.identity : null;
        if (this.thirdPartyExists !== null) {
            this.foundThirdParty = this.thirdPartyExists;
        } else {
            this.foundThirdParty = this.thirdParty && this.thirdParty.identity !== null || null;
        }

        this.debouncer
        .debounceTime(delayBeforeSearch)
        .subscribe(() => {
            this.fetchThirdParty();
        });
        this.searching = false;
    }

    fetchThirdParty() {
        // if the field is empty, we emit an empty third party
        if (!this.search) {
            this.thirdParty = new ThirdParty();
            this.thirdParty.fromJSON({
                identity: null,
                label: null
            });
            this.onNewSearch.emit({
                thirdParty: this.thirdParty,
                found: false
            });
            return;
        }
        this.searching = true;
        this.onSearchEvent.emit(this.searching);
        this.relationSearchService
        .searchThirdPartyByRelation(this.search, this.relationDestination, this.thirdPartyRelationType)
        .finally(() => {
            this.searching = false;
            this.onSearchEvent.emit(this.searching);
        })
        .subscribe((thirdParty) => {
            // check if we have found the third party
            this.foundThirdParty = thirdParty !== null;
            if (this.foundThirdParty) {
                // we replace the third party by the current one to display the label in the view
                this.thirdParty = thirdParty;
            } else {
                this.thirdParty = new ThirdParty();
                this.thirdParty.fromJSON({
                    identity: this.search,
                    label: null
                });
            }
            this.onNewSearch.emit({
                thirdParty: this.thirdParty,
                found: this.foundThirdParty
            });
        });
    }

    searchThirdParty() {
        this.debouncer.next();
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-infos/relation-search/relation-search.component.ts